/* eslint-disable no-await-in-loop */
/* eslint-disable new-cap */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-loop-func */
//
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Form } from '@unform/web';
import { HiCheck, HiOutlineBan } from 'react-icons/hi';
import { useHistory, useParams } from 'react-router-dom';
import { QRCode } from 'react-qrcode-logo';
import Swal from 'sweetalert2';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { io, Socket } from 'socket.io-client';

import { AxiosError } from 'axios';
import { Container, Modal } from './styles';
import Input from '~/components/Input';
import { KrDoubt, KrShoppingCart, KrUsers } from '~/components/KoroIcons';
import checklist from '~/assets/icons/checklist.svg';
import ButtonBack from '~/components/ButtonBack';
import InputCheckbox from '~/components/InputCheckbox';
import PaymentMethod from '~/components/PaymentMethod';
import { useCart } from '~/hooks/Cart';
import { formatPrice } from '~/utils/format';
import api from '~/services/api';
import logoQrcode from '~/assets/logos/logo-qrcode.svg';
import Toast from '~/utils/toast';
import { useAuth } from '~/hooks/Auth';
import ModalTerms from './ModalTerms';
import ModalRegulations from './ModalRegulations';
import Ticket from '~/components/Ticket';
import { useResize } from '~/hooks/Resize';
import { useMarketing, IItem as IItemMarketing } from '~/hooks/Marketing';
import ButtonHome from '~/components/ButtonHome';

interface IPeople {
  name?: string;
  document?: string;
}

interface ISummary {
  modality: string;
  category: string;
  peoples: IPeople[];
  subtotal: number;
  quantity: number;
}

interface IParams {
  slug: string;
}

interface IValue {
  id: number;
  type: string;
  installment: number;
  tax_percent: string;
  tax_price: string;
  koro_deadline: number;
  gateway_deadline: number;
}

interface IGatewayResponse {
  id: number;
  account_id: string;
  anticipation: boolean;
  company: {
    document: string;
    name: string;
    fantasy_name: string;
    support_email: string;
    finance_email: string;
    address: {
      street: string;
      number: string;
      neighborhood: string;
      city: string;
      state: string;
      country: string;
      complement: string;
      zip_code: string;
    };
  };
  values: IValue[];
}

interface ITicketResponse {
  id: number;
  document: string;
  name: string;
  email: string;
  phone: string;
  code: string;
  orderItem: {
    event: {
      id: number;
      name: string;
      date: string;
      address: {
        full_address: string;
      };
    };
  };
  modality: {
    name: string;
  };
  batchCategory: {
    category: {
      name: string;
    };
  };
  kitUser?: {
    color?: {
      name: string;
    };
    size?: {
      size: string;
    };
  };
}

interface ITicket {
  id: number;
  code: string;
  event: string;
  event_date: string;
  name: string;
  document: string;
  modality: string;
  category: string;
  address: string;
  email: string;
  phone: string;
  event_id: string;
  kit?: {
    color?: string;
    size?: string;
  };
}

let trackPayment: NodeJS.Timeout;

const CheckoutPayment: React.FC = () => {
  const {
    trackStartPayment,
    trackCheckout,
    setEventId: setEventIdMarketing,
  } = useMarketing();
  const params = useParams<IParams>();
  const { width } = useResize();
  const { user } = useAuth();
  const {
    cart,
    handleChangeItems,
    setFillBefore: setFillBeforeCard,
  } = useCart();
  const history = useHistory();
  const [socket, setSocket] = useState<Socket | undefined>();
  const [terms, setTerms] = useState(false);
  const [payment, setPayment] = useState(false);
  const [validVoucher, setValidVoucher] = useState(false);
  const [invalidVoucher, setInvalidVoucher] = useState(false);
  const [serviceFee, setServiceFee] = useState(0);
  const [processingFee, setProcessingFee] = useState(0);
  const [subtotal, setSubtotal] = useState(0);
  const [total, setTotal] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [success, setSuccess] = useState(false);
  const [regulations, setRegulations] = useState(false);
  const [term, setTerm] = useState(false);
  const [voucherId, setVoucherId] = useState<number | undefined>(undefined);
  const [qrCode, setQrCode] = useState('');
  const [show, setShow] = useState(false);
  const [eventId, setEventId] = useState<number | undefined>(undefined);
  const [batchId, setBatchId] = useState<number | undefined>(undefined);
  const [fillBefore, setFillBefore] = useState(0);
  const [organizerId, setOrganizerId] = useState<number | undefined>(undefined);
  const [serviceTaxType, setServiceTaxType] = useState('Porcentagem');
  const [serviceTax, setServiceTax] = useState(0);
  const [processingTaxType, setProcessingTaxType] = useState('Porcentagem');
  const [processingTax, setProcessingTax] = useState(0);
  const [orderId, setOrderId] = useState<number | undefined>(undefined);
  const [generating, setGenerating] = useState(false);
  const [tickets, setTickets] = useState<ITicket[]>([]);
  const [hasPix, setHasPix] = useState(false);
  const [hasCredit, setHasCredit] = useState(false);
  const [installments, setInstallments] = useState(1);
  const [monthlyTax, setMonthlyTax] = useState(0);
  const [widthShare, setWidthShare] = useState(0);
  const [freePayment, setFreePayment] = useState(false);
  const [freePaymentDiscount, setFreePaymentDiscount] = useState(false);
  const [contractId, setContractId] = useState<number | undefined>(undefined);

  const [timeLeft, setTimeLeft] = useState(300);

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (show) {
      setTimeLeft(300);
      timer = setInterval(() => {
        setTimeLeft((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            setPayment(false);
            setShow(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [show]);

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  useEffect(() => {
    if (width > 575) {
      setWidthShare(70);
    } else {
      setWidthShare(35);
    }
  }, [width]);

  useEffect(() => {
    const socketInstance = io(process.env.REACT_APP_API_URL as string, {
      reconnection: true,
    });

    // subir

    socketInstance.on('connect', () => {
      // console.log('Conectado');
    });

    socketInstance.on('disconnect', () => {
      // console.log(error);
    });

    socketInstance.on('error', () => {
      // console.log(error);
    });

    setSocket(socketInstance);

    return () => {
      socketInstance.disconnect();
      socketInstance.offAny();
    };
  }, []);

  useEffect(() => {
    if (success) {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            stausBarColor: '#ff6900',
          })
        );
      }
    }
  }, [success]);

  const confirmPayment = useCallback(
    (purchaseOrderId?: number) => {
      clearInterval(trackPayment);
      const trackItems = cart.items.map<IItemMarketing>((item) => ({
        id:
          item.ticket?.id.toString() ||
          `${item.batch_category_id}-${item.modality_id}`,
        name: `${item.category} - ${item.modality}`,
        quantity: item.quantity,
        price: item.value,
      }));
      let txId: string | undefined;
      if (purchaseOrderId) {
        txId = `KORO_${purchaseOrderId}`;
      } else if (orderId) {
        txId = `KORO_${orderId}`;
      } else {
        txId = undefined;
      }
      trackCheckout(trackItems, txId);
      if (fillBefore === 1) {
        setGenerating(true);
      } else {
        setSuccess(true);
      }
    },
    [cart.items, fillBefore, orderId, trackCheckout]
  );

  useEffect(() => {
    if (orderId) {
      socket?.on(`order-${orderId}`, (status: string) => {
        setShow(false);
        if (status === 'Pago') {
          confirmPayment();
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Ocorreu um realizar o pagamento tente novamente, por favor',
          });
        }
      });
    }
  }, [confirmPayment, orderId, socket]);

  useEffect(() => {
    if (orderId && fillBefore === 1) {
      api
        .get<ITicketResponse[]>(`tickets/events/users/${eventId}/${orderId}`)
        .then((response) => {
          const data = response.data.map<ITicket>((ticket) => {
            return {
              id: ticket.id,
              code: ticket.code,
              event_id: ticket.orderItem.event.id.toString(),
              event: ticket.orderItem.event.name,
              event_date: ticket.orderItem.event.date,
              name: ticket.name,
              document: ticket.document,
              email: ticket.email,
              phone: ticket.phone,
              modality: ticket.modality.name,
              category: ticket.batchCategory.category.name,
              address: `${ticket.orderItem.event.address.full_address}`,
              kit: ticket.kitUser
                ? {
                    color: ticket.kitUser.color?.name,
                    size: ticket.kitUser.size?.size,
                  }
                : undefined,
            };
          });

          setTickets(data);
        });
    }
  }, [eventId, fillBefore, orderId]);

  useEffect(() => {
    if (generating && tickets.length > 0) {
      let index = 0;
      for (const ticket of tickets) {
        if (
          ticket.document !== user.additionalInformation.document &&
          fillBefore === 1
        ) {
          const divElement = document.getElementById(`ticket-${ticket.code}`);
          if (divElement) {
            const pdfWidth = divElement.offsetWidth;
            const pdfHeight = divElement.offsetHeight;
            html2canvas(divElement, {
              width: width > 550 ? pdfWidth + 85 : pdfWidth + 45,
              height: pdfHeight + 30,
            }).then((canvas) => {
              const imgData = canvas.toDataURL('image/png');
              const pdf = new jsPDF({
                unit: 'px',
                format: [pdfWidth, pdfHeight],
              });
              pdf.addImage(
                imgData,
                'PNG',
                5,
                5,
                pdfWidth + widthShare,
                pdfHeight
              );
              const ticketFile = pdf.output('blob');
              const ticketFormData = new FormData();
              ticketFormData.append('ticket', ticketFile);
              ticketFormData.append('ticket_id', ticket.id.toString());
              api.post('tickets/emails', ticketFormData);
            });
          }
        }

        if (index === tickets.length - 1) {
          setSuccess(true);
          setGenerating(false);
        }
        index += 1;
      }
    }
  }, [
    fillBefore,
    generating,
    tickets,
    tickets.length,
    user.additionalInformation.document,
    width,
    widthShare,
  ]);

  useEffect(() => {
    const eventData = localStorage.getItem('@Koro:event');
    if (eventData) {
      const parsedEvent = JSON.parse(eventData);
      if (parsedEvent.slug === params.slug) {
        setEventId(parsedEvent.id);
        setEventIdMarketing(parsedEvent.id);
        setBatchId(parsedEvent.batch_id);
        setFillBefore(parsedEvent.fill_before);
        setFillBeforeCard(parsedEvent.fill_before);
        setOrganizerId(parsedEvent.organizer_id);
        setServiceTaxType(parsedEvent.contract.service_type);
        setServiceTax(parseFloat(parsedEvent.contract.service));
        setProcessingTaxType(parsedEvent.contract.tax_type);
        setProcessingTax(parseFloat(parsedEvent.contract.tax));
        const freePaymentData = parsedEvent.free;
        setFreePayment(freePaymentData);
        setContractId(parsedEvent.contract.id);

        if (!freePaymentData) {
          setHasPix(
            parsedEvent.paymentsMethods.some(
              (eventPaymentMethod: any) =>
                eventPaymentMethod.paymentMethod.name === 'Pix'
            )
          );
          const credit = parsedEvent.paymentsMethods.find(
            (eventPaymentMethod: any) =>
              eventPaymentMethod.paymentMethod.name === 'Crédito'
          );

          if (credit) {
            setMonthlyTax(parseFloat(parsedEvent.contract.monthly_tax));
            setInstallments(credit.installments);
            setHasCredit(true);
          }
        }
      } else {
        history.push(`/eventos/${params.slug}`);
      }
    } else {
      history.push(`/eventos/${params.slug}`);
    }
  }, [history, params.slug, setEventIdMarketing, setFillBeforeCard]);

  const summary = useMemo(
    () =>
      cart.items.reduce((previous, current) => {
        const prev = previous;

        const itemIndex = prev.findIndex(
          (item) =>
            `${item.modality}-${item.category}` ===
            `${current.modality}-${current.category}`
        );

        if (itemIndex >= 0) {
          if (cart.isFillBeforeTicket === 1) {
            prev[itemIndex].peoples.push({
              name: current.ticket?.name || '',
              document: current.ticket?.document || '',
            });
          }

          prev[itemIndex].quantity += 1;
          prev[itemIndex].subtotal = current.value * prev[itemIndex].quantity;
        } else {
          prev.push({
            modality: current.modality,
            category: current.category,
            peoples:
              cart.isFillBeforeTicket === 1
                ? [
                    {
                      name: current.ticket?.name || '',
                      document: current.ticket?.document || '',
                    },
                  ]
                : [],
            quantity: 1,
            subtotal: current.value * 1,
          });
        }
        return prev;
      }, [] as ISummary[]),
    [cart.isFillBeforeTicket, cart.items]
  );

  useEffect(() => {
    const data = summary.reduce((previous, current) => {
      return previous + current.subtotal;
    }, 0);

    setSubtotal(freePayment ? 0 : data);
  }, [eventId, freePayment, processingFee, serviceFee, summary]);

  useEffect(() => {
    if (subtotal) {
      if (serviceTaxType === 'Porcentagem') {
        setServiceFee(subtotal * (serviceTax / 100));
      } else {
        setServiceFee(serviceTax);
      }
      if (processingTaxType === 'Porcentagem') {
        setProcessingFee(subtotal * (processingTax / 100));
      } else {
        setProcessingFee(processingTax);
      }
    }
  }, [processingTax, processingTaxType, serviceTax, serviceTaxType, subtotal]);

  useEffect(() => {
    // console.log(subtotal, serviceFee, processingFee, discount);
    setTotal(
      freePayment ? 0 : subtotal + serviceFee + processingFee - discount
    );
  }, [discount, freePayment, processingFee, serviceFee, subtotal]);

  const handleChangeVoucher = useCallback(
    async (e) => {
      setFreePaymentDiscount(false);
      const { value } = e.target;
      if (value.length > 0) {
        const response = await api.get(`vouchers/${value}/${eventId}`);
        if (response.data) {
          let data = 0;
          const available =
            response.data.quantity - response.data.used_quantity;
          let used = 0;

          const responseOrder = await api.get(
            `orders/vouchers/${response.data.id}`
          );

          if (
            !response.data.unique_code_use &&
            responseOrder.data &&
            (responseOrder.data.status === 'Pago' ||
              responseOrder.data.status === 'DEVOLUÇÃO PARCIAL')
          ) {
            setVoucherId(undefined);
            setDiscount(0);
            setTotal(subtotal + serviceFee + processingFee);
            setValidVoucher(false);
            setInvalidVoucher(true);
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Você já usou este cupom em outro pedido.',
            });
          } else if (available < cart.items.length) {
            setVoucherId(undefined);
            setDiscount(0);
            setTotal(subtotal + serviceFee + processingFee);
            setValidVoucher(false);
            setInvalidVoucher(true);
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: `Seu pedido tem mais ingressos que a quantidade de cupons disponíveis, temos ${available} cupon${
                available > 1 ? 's' : ''
              } disponíveis.`,
            });
          } else {
            if (response.data.percent) {
              if (parseInt(response.data.percent, 10) === 100) {
                data = 0;
                setDiscount(subtotal + serviceFee + processingFee);
                setFreePaymentDiscount(true);
                setTotal(0);
              } else {
                const discountData = summary.reduce((previous, current) => {
                  const remaining = available - used;
                  if (remaining <= 0) {
                    return previous;
                  }

                  const discountableQty = Math.min(current.quantity, remaining);
                  const unitPrice = current.subtotal / current.quantity;
                  const discountTotal =
                    (unitPrice *
                      discountableQty *
                      parseFloat(response.data.percent)) /
                    100;

                  used += discountableQty;
                  return previous + discountTotal;
                }, 0);
                data = subtotal - discountData;
                setDiscount(discountData);
              }
            } else if (response.data.price) {
              const discountData = summary.reduce((previous, current) => {
                const remaining = available - used;

                if (remaining <= 0) {
                  return previous;
                }

                const discountableQty = Math.min(current.quantity, remaining);
                const totalDiscount =
                  discountableQty * parseFloat(response.data.price);
                used += discountableQty;
                return previous + totalDiscount;
              }, 0);
              data = subtotal - discountData;
              setDiscount(discountData);
            }
            setTotal(data);
            setInvalidVoucher(false);
            setValidVoucher(true);
            setVoucherId(response.data.id);
          }
        } else {
          setVoucherId(undefined);
          setDiscount(0);
          setTotal(subtotal + serviceFee + processingFee);
          setValidVoucher(false);
          setInvalidVoucher(true);
        }
      } else {
        setVoucherId(undefined);
        setDiscount(0);
        setTotal(subtotal + serviceFee + processingFee);
        setValidVoucher(false);
        setInvalidVoucher(false);
      }
    },
    [cart.items.length, eventId, processingFee, serviceFee, subtotal, summary]
  );

  const handleSubmit = useCallback(async () => {
    const trackItems = cart.items.map<IItemMarketing>((item) => ({
      id:
        item.ticket?.id.toString() ||
        `${item.batch_category_id}-${item.modality_id}`,
      name: `${item.category} - ${item.modality}`,
      quantity: item.quantity,
      price: item.value,
    }));
    trackStartPayment(trackItems);
    setPayment(true);
  }, [cart.items, trackStartPayment]);

  const handleExpiredOrder = useCallback(
    (message?: string) => {
      handleChangeItems([]);
      sessionStorage.removeItem(`@Koro:qtyTickets_${eventId}`);
      Swal.fire({
        icon: 'warning',
        title: 'Pedido expirado',
        html: `<p>${
          message ? `${message}<br>` : ''
        }Selecione novamente a modalidade e categoria.</p>`,
        confirmButtonColor: '#ff6900',
      }).then(() => {
        history.push(`${process.env.PUBLIC_URL}/eventos/${params.slug}`);
      });
    },
    [eventId, handleChangeItems, history, params.slug]
  );

  const handlePaymentMethodSelected = useCallback(
    async (paymentMethod) => {
      try {
        const csvLotcat = cart.items
          .map((item) => item.batch_category_id)
          .join(',');
        const hasKitStock = cart.items.some(
          (item) => item.ticket?.kit?.stock_control
        );
        const csvKqt = hasKitStock
          ? cart.items
              .map((item) => item.ticket?.kit?.quantity_id ?? '')
              .join(',')
          : '';

        await api.post('payments/validate-order', {
          event_id: eventId,
          csv_lotcat: csvLotcat,
          csv_kqt: csvKqt,
        });
      } catch (error) {
        const err = error as AxiosError;
        handleExpiredOrder(err?.response?.data?.message);
        return;
      }

      try {
        let newTotal = total;

        if (paymentMethod.installments > 1) {
          const installmentValue =
            (total * monthlyTax) /
            (1 - (1 + monthlyTax) ** -paymentMethod.installments);

          newTotal = parseFloat(
            (installmentValue * paymentMethod.installments).toFixed(2)
          );
        }

        const [gatewayResponse, contractResponse] = await Promise.all([
          api.get<IGatewayResponse>('gateways/1'),
          api.get(`contracts/${contractId}`),
        ]);

        const gatewayValue = gatewayResponse.data.values.find(
          (value) =>
            value.type === paymentMethod.type &&
            value.installment === paymentMethod.installments
        );

        const normalizeStr = (str: string) =>
          str
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase();

        const contractValue = contractResponse.data.contractsValues.find(
          (value: any) =>
            normalizeStr(value.type) === normalizeStr(paymentMethod.type)
        );

        let gatewayFee = 0;
        let organizer_deadline = 0;
        let koro_deadline = 0;

        if (contractValue) {
          organizer_deadline = contractValue.organizer_deadline;
        }

        if (gatewayValue) {
          gatewayFee =
            newTotal * parseFloat(gatewayValue.tax_percent) +
            parseFloat(gatewayValue.tax_price);
          koro_deadline = gatewayValue.koro_deadline;
        }

        const organizerValue = parseFloat((subtotal - discount).toFixed(2));

        let flag = paymentMethod.card?.flag;

        if (paymentMethod.type.includes('CREDIT')) {
          if (flag?.includes('static')) {
            if (flag.includes('mastercard')) {
              flag = 'Mastercard';
            }
            if (flag.includes('visa')) {
              flag = 'Visa';
            }
            if (flag.includes('american-express')) {
              flag = 'American Express';
            }
            if (flag.includes('elo')) {
              flag = 'Elo';
            }
          }
        }

        const totalwithOutDiscount = newTotal + discount;

        const items = cart.items.map((item) => {
          const [day, month, year] = item.ticket?.birthdate
            ? item.ticket.birthdate.split('/')
            : [];

          return {
            batch_category_id: item.batch_category_id,
            modality_id: item.modality_id,
            value: freePayment ? 0 : item.value,
            voucher_id: voucherId,
            ticket: {
              document: item.ticket?.document,
              name: item.ticket?.name,
              email: item.ticket?.email,
              phone: item.ticket?.phone,
              gender: item.ticket?.gender,
              birthdate: year
                ? `${year}-${month}-${day}`
                : item.ticket?.birthdate,
              answers: item.ticket?.answers || [],
              kit: item.ticket?.kit
                ? {
                    id: item.ticket.kit.id,
                    size: item.ticket.kit.size,
                    quantity_id: item.ticket.kit.quantity_id,
                  }
                : undefined,
            },
          };
        });

        let cardFields = {};
        if (paymentMethod.card?.fullNumber) {
          cardFields = {
            card_name: paymentMethod.card.name,
            card_number: paymentMethod.card.fullNumber,
            card_due_date: paymentMethod.card.due_date,
            card_flag: flag,
            card_cvc: paymentMethod.card.cvc,
          };
        } else if (paymentMethod.card?.id) {
          cardFields = { card_id: paymentMethod.card.id };
        }

        const formData = {
          event_id: eventId,
          organizer_id: organizerId,
          voucher_id: voucherId,
          batch_id: batchId,
          name: user.name,
          email: user.email,
          document: paymentMethod.document,
          phone: paymentMethod.phone,
          service_fee: freePayment ? 0 : serviceFee,
          processing_fee: freePayment ? 0 : processingFee,
          discount: parseFloat(discount.toFixed(2)),
          total: parseFloat(totalwithOutDiscount.toFixed(2)),
          quantity_total: cart.items.length,
          installments: paymentMethod.installments,
          gateway_id: gatewayResponse.data.id,
          payment_type: paymentMethod.type,
          installment: paymentMethod.installments,
          price: parseFloat(newTotal.toFixed(2)),
          gateway_fee: parseFloat(gatewayFee.toFixed(2)),
          organizer_value: newTotal <= 0 ? 0 : organizerValue,
          organizer_deadline,
          koro:
            newTotal <= 0
              ? 0
              : parseFloat((newTotal - organizerValue - gatewayFee).toFixed(2)),
          koro_deadline,
          items,
          ...cardFields,
        };

        const response = await api.post('checkout', formData);

        if (response.data.qrCode) {
          setQrCode(response.data.qrCode);
          setShow(true);
          setOrderId(response.data.order_id);

          trackPayment = setInterval(async () => {
            const responsePayment = await api.get(
              `payments/${response.data.payment_id}`
            );

            if (responsePayment.data.status === 'Pago') {
              setShow(false);
              confirmPayment();
            }
          }, 30000);
        } else {
          handleChangeItems([]);

          const trackItems = cart.items.map<IItemMarketing>((item) => ({
            id:
              item.ticket?.id.toString() ||
              `${item.batch_category_id}-${item.modality_id}`,
            name: `${item.category} - ${item.modality}`,
            quantity: item.quantity,
            price: freePayment ? 0 : item.value,
          }));
          trackCheckout(trackItems, `KORO_${response.data.order_id}`);

          if (fillBefore !== 1) {
            setSuccess(true);
          } else {
            setGenerating(true);
            setOrderId(response.data.order_id);
          }
        }
      } catch (error) {
        let errorMessage =
          'Ocorreu um erro com pagamento verifique seus dados e tente novamente, por favor';

        const err = error as AxiosError;
        if (
          err.response &&
          err.response.data &&
          err.response.data.message &&
          err.response.data.message !== 'Internal Server Error'
        ) {
          errorMessage = err.response.data.message;
        }

        Swal.fire('Oops...', errorMessage, 'error').then(() => {
          setPayment(false);
          setQrCode('');
          setShow(false);
        });
      }
    },
    [
      batchId,
      cart.items,
      confirmPayment,
      contractId,
      discount,
      eventId,
      fillBefore,
      freePayment,
      handleChangeItems,
      handleExpiredOrder,
      monthlyTax,
      organizerId,
      processingFee,
      serviceFee,
      subtotal,
      total,
      trackCheckout,
      user.email,
      user.name,
      voucherId,
    ]
  );

  const handleClickConfirm = useCallback(() => {
    sessionStorage.removeItem(`@Koro:qtyTickets_${eventId}`);
    history.push(`${process.env.PUBLIC_URL}/meus-ingressos/proximos`);
  }, [eventId, history]);

  const handleClickCopyPix = useCallback(async () => {
    await navigator.clipboard.writeText(qrCode);
    Toast.fire({
      icon: 'success',
      iconColor: '#ff6900',
      title: 'Código copiado!',
    });
  }, [qrCode]);

  return (
    <>
      {payment ? (
        <PaymentMethod
          payment
          onClickBack={() => setPayment(false)}
          onPaymentMethodSelected={handlePaymentMethodSelected}
          onClickConfirm={handleClickConfirm}
          success={success}
          generating={generating}
          freePayment={freePayment || freePaymentDiscount}
          hasPix={!freePaymentDiscount && hasPix}
          hasCredit={!freePaymentDiscount && hasCredit}
          total={total}
          installments={installments}
          monthlyTax={monthlyTax}
        />
      ) : (
        <Container>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-11 text-center pt-3">
                <div className="d-flex justify-content-between">
                  <ButtonBack className="btn-back" />
                  <ButtonHome className="" />
                </div>
                <div className="d-flex align-items-center justify-content-between my-3">
                  <h2 className="h4 mb-0 d-flex align-items-center">
                    <img src={checklist} alt="Check" className="me-2" />
                    Resumo
                  </h2>
                </div>
                <h4 className="text-start mb-3">
                  Este é o resumo do seu pedido, verifique as informações para
                  prosseguir com o pagamento.
                </h4>
              </div>

              <div className="col-11">
                <Form
                  onSubmit={handleSubmit}
                  className="d-flex flex-column pb-3"
                >
                  <div className="border-ticket p-3 mb-3">
                    <h3 className="d-flex align-items-center h5 text-black">
                      <KrUsers size={20} color="#292623" className="me-2" />
                      Pessoas e Ingressos
                    </h3>
                    {summary.map((item, index) => (
                      <div
                        className={`${
                          summary.length - 1 !== index && 'border-bottom'
                        } mt-3`}
                      >
                        <p className="d-flex justify-content-between mb-0">
                          <span className="h6 fw-semibold text-black mb-1">
                            {item.quantity}x {item.modality}
                          </span>{' '}
                          <span className="h6 fw-semibold text-black mb-1">
                            {formatPrice(freePayment ? 0 : item.subtotal)}
                          </span>
                        </p>

                        <p className="">Categoria: {item.category || '-'}</p>
                        <ul>
                          {item.peoples.map((people) => (
                            <li className="pb-3">
                              <span className="d-block">
                                {people.name || 'Nome: Não preenchido'}
                              </span>
                              <span className="d-block">
                                Documento: {people.document || 'Não preenchido'}
                              </span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                  <div className="discount mb-3">
                    <div className="title p-2">Inserir cupom de desconto</div>
                    <div className="bd-discount d-flex align-items-center px-2">
                      <Input
                        name="voucher"
                        className="ps-0"
                        onChange={handleChangeVoucher}
                        placeholder="Digite aqui"
                      />
                      {validVoucher && (
                        <HiCheck
                          size={16}
                          color="#00A3E0"
                          className="check-icon"
                        />
                      )}
                      {invalidVoucher && (
                        <HiOutlineBan
                          size={16}
                          color="#FF003D"
                          className="check-icon"
                        />
                      )}
                    </div>
                  </div>
                  <div className="border-ticket values p-3 mb-3">
                    <h3 className="d-flex align-items-center h5 text-black">
                      <KrShoppingCart
                        size={20}
                        color="#292623"
                        className="me-2"
                      />
                      Resumo de valores
                    </h3>
                    {summary.map((item) => (
                      <p className="d-flex mb-0 mt-3">
                        <span>
                          {item.quantity}x {item.modality}
                        </span>
                        <span className="dot" />
                        <span>
                          {formatPrice(freePayment ? 0 : item.subtotal)}
                        </span>
                      </p>
                    ))}

                    <p className="d-flex mb-0 mt-3">
                      <span>Taxa de serviço</span>
                      <span className="dot" />
                      <span>{formatPrice(freePayment ? 0 : serviceFee)}</span>
                    </p>
                    <p className="d-flex mb-0 mt-3 position-relative">
                      <span>
                        Taxa de processamento
                        <button
                          type="button"
                          className="tooltip-tax border-0 bg-transparent ms-1"
                          data-tooltip="A taxa de processamento é o custo que será repassado ao serviço de transação online para operacionalizar o pagamento"
                        >
                          <KrDoubt size={16} color="#8C8C8C" />
                        </button>
                      </span>
                      <span className="dot" />
                      <span>
                        {formatPrice(freePayment ? 0 : processingFee)}
                      </span>
                    </p>
                    <p className="d-flex mb-0 mt-3">
                      <span>Cupons e descontos</span>
                      <span className="dot" />
                      <span className="color-desc">
                        - {formatPrice(discount)}
                      </span>
                    </p>
                    <p className="total mb-0 mt-3">
                      Total: <span>{formatPrice(total)}</span>
                    </p>
                  </div>

                  <InputCheckbox
                    type="checkbox"
                    name="terms"
                    className="mb-3 d-block check"
                    options={[
                      {
                        labelHtml: true,
                        label: (
                          <>
                            Li e estou de acordo com o{' '}
                            <button
                              type="button"
                              onClick={() => setRegulations(true)}
                            >
                              regulamento
                            </button>{' '}
                            e{' '}
                            <button type="button" onClick={() => setTerm(true)}>
                              termos de responsabilidade
                            </button>{' '}
                            deste evento.
                          </>
                        ),
                        value:
                          'Li e estou de acordo com o regulamento e termos de responsabilidade deste evento.',
                        selected: terms,
                      },
                    ]}
                    onChange={() => setTerms(!terms)}
                  />

                  <button
                    type="submit"
                    disabled={!terms}
                    className={`${
                      !terms && 'opacity-50'
                    } btn btn-login h6 fw-normal py-2 mt-3 mb-0`}
                  >
                    Continuar
                  </button>
                </Form>
              </div>
            </div>
          </div>
        </Container>
      )}
      <ModalTerms show={term} onClose={() => setTerm(false)} />
      <ModalRegulations
        show={regulations}
        onClose={() => setRegulations(false)}
      />
      <Modal show={show}>
        <Modal.Header className="d-flex align-items-center justify-content-center">
          <Modal.Title className="mb-0">Qr Code Pix</Modal.Title>
        </Modal.Header>
        <Modal.Body className="d-flex flex-column align-items-center justify-content-center">
          <QRCode
            value={qrCode}
            removeQrCodeBehindLogo
            logoImage={logoQrcode}
            logoPadding={5}
            size={250}
            ecLevel="L"
          />
          <p className="h6 fw-bold text-center text-danger mt-3 mb-0">
            ** O Código expirará em {minutes}:
            {seconds.toString().padStart(2, '0')} minuto{minutes > 1 && 's'}**
          </p>
        </Modal.Body>
        <Modal.Footer className="d-flex align-items-center justify-content-center">
          <button
            type="button"
            className="copy-btn border-0 py-2 px-4 text-center mt-3"
            onClick={handleClickCopyPix}
          >
            Copiar código pix
          </button>
        </Modal.Footer>
      </Modal>
      {tickets.length > 0 && (
        <div className="opacity-0">
          {tickets.map((ticket) => (
            <Ticket key={ticket.id} ticket={ticket} />
          ))}
        </div>
      )}
    </>
  );
};

export default CheckoutPayment;
